interface LogoIconProps {
	size?: number;
	className?: string;
}

export function LogoIcon({ size = 24, className }: LogoIconProps) {
	return (
		<svg
			viewBox="0 0 150 133"
			width={size}
			height={size * (133 / 150)}
			className={className}
			aria-hidden="true"
		>
			<path
				d="M 66.42 118.08 C66.19,117.85 66.00,108.29 66.00,96.83 L 66.00 76.00 L 62.93 76.00 C60.57,76.00 59.93,75.60 60.18,74.29 C60.43,73.01 62.73,72.14 69.50,70.78 C74.44,69.79 79.05,69.19 79.74,69.46 C80.70,69.82 81.00,75.31 81.00,92.47 L 81.00 115.00 L 102.50 115.00 L 124.00 115.00 L 124.00 86.54 L 124.00 58.09 L 99.25 41.08 C85.64,31.72 73.78,24.05 72.90,24.03 C71.33,24.00 27.69,53.24 23.23,57.31 C20.97,59.37 20.97,59.42 21.23,86.94 L 21.50 114.50 L 38.25 114.77 C52.23,115.00 55.00,115.29 55.00,116.52 C55.00,117.77 52.28,118.00 37.62,118.00 C24.94,118.00 19.97,117.66 19.21,116.75 C17.96,115.23 17.11,58.10 18.32,56.24 C18.77,55.54 21.69,53.26 24.82,51.17 C30.27,47.52 37.14,42.82 59.91,27.16 C65.88,23.06 71.37,20.00 72.78,20.00 C74.13,20.00 77.32,21.50 79.87,23.34 C82.41,25.18 93.05,32.42 103.50,39.44 C113.95,46.46 123.74,53.51 125.25,55.11 L 128.00 58.03 L 128.00 86.32 C128.00,107.40 127.68,115.04 126.75,116.29 C125.64,117.78 122.23,117.99 96.17,118.23 C80.03,118.38 66.64,118.31 66.42,118.08 ZM 70.00 63.33 C69.18,63.01 67.26,61.60 65.75,60.19 C62.00,56.69 61.86,50.05 65.45,46.45 C68.83,43.08 75.75,43.02 79.59,46.33 C83.41,49.61 83.62,56.83 80.00,60.45 C77.44,63.01 72.69,64.38 70.00,63.33 Z"
				fill="currentColor"
			/>
		</svg>
	);
}
